import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDefectsByPositionShort } from './api';

export const path = '/application/new';

const PageApplicationNew: React.FC = (props) => {
  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      defects: getDefectsByPositionShort,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageApplicationNew;
